

export const Loading = () => {
    return <div>Загрузка...</div>
}